var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "#303030"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0008 18.9995C12.7356 18.9995 12.4813 19.1048 12.2937 19.2923C12.1062 19.4799 12.0008 19.7342 12.0008 19.9995V33.4995C12.0008 35.3895 13.6108 36.9995 15.5008 36.9995H32.5008C34.3908 36.9995 36.0008 35.4676 36.0008 33.5776V19.9995C36.0008 19.7342 35.8955 19.4799 35.7079 19.2923C35.5204 19.1048 35.266 18.9995 35.0008 18.9995H13.0008Z",
    stroke: "#E4FD3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0011 19.0012V17.0009C18.0011 15.4094 18.6333 13.883 19.7587 12.7576C20.8841 11.6323 22.4104 11 24.0019 11V11C25.5934 11 27.1198 11.6323 28.2452 12.7576C29.3705 13.883 30.0028 15.4094 30.0028 17.0009V19.0012",
    stroke: "#E4FD3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0011 21.9993V22.9995C18.0011 24.591 18.6333 26.1173 19.7587 27.2427C20.8841 28.3681 22.4104 29.0003 24.0019 29.0003C25.5934 29.0003 27.1198 28.3681 28.2452 27.2427C29.3705 26.1173 30.0028 24.591 30.0028 22.9995V21.9993",
    stroke: "#E4FD3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromos);
export default __webpack_public_path__ + "static/media/promos.75d53d74398fdedb5b7600ae067256f7.svg";
export { ForwardRef as ReactComponent };